export default __webpack_public_path__ + "images/60881f24a9f00984b31339f432a919c9.svg";